'use strict';

var billing = require('./billing'),
	multiship = require('./multiship'),
	shipping = require('./shipping'),
	summary = require('./summary'),
	address = require('./address'),
	util = require('../../util'),
	registration = require('../../registration'),
	login = require('../../login'),
	linchpin = require('int_googletagmanager/linchpin/orderreview'),
	iscroll = require('../../iscroll');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {

	if ($('.checkout-shipping').length > 0) {
		shipping.init();
		address.deliveryAddressChangeHandler();
	} else if ($('.checkout-multi-shipping').length > 0) {
		multiship.init();
	} else if ($('.checkout-billing').length > 0) {
		billing.init();
	} else if ($('#RegistrationForm').length > 0) {
		registration.init();
	} else if ($('.login-intercept').length > 0) {
		login.init();
	} else if ($('.submit-order').length > 0) {
		summary.init();
	}

	//if on the order review page and there are products that are not available disable the submit order button
	if ($('.order-summary-footer').length > 0) {
		if ($('.notavailable').length > 0) {
			$('.order-summary-footer .submit-order .button-fancy-large').prop('disabled', true);
		}
	}

	// init custom scroll
	iscroll.init();

	// refs HCS-47 removing emoji and invalid chars from text input fields
	$('textarea, input.input-text').on('change', function () {
		this.value = util.removeInvalidChars(this.value);
	});
	$('input[type="text"][name*="_addressFields_"]').on('change', function () {
		this.value = util.replaceInvalidChars(this.value);
	});

	// handle update of delivery date to say 'NOW' when it's current date
	var deliveryDates = $('.delivery-type-sms .date');
	if (deliveryDates.length) {
		var currentDate = new Date();
		var dateArray = [];
		dateArray.push(currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate());
		dateArray.push(currentDate.getMonth() < 9 ? '0' + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1));
		dateArray.push(currentDate.getYear() + 1900);
		var currentDateString = dateArray.join('/');
		deliveryDates.each(function () {
			var dateTextValue = $(this).text();
			if (dateTextValue === currentDateString) {
				$(this).text('NOW - ' + dateTextValue);
			}
		});
	}
	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		linchpin.orderReviewEvent();
	}
};
